import MyActionButton from './ActionButton'
import MyClearButton from './ClearButton'
import MyFlipHorizontallyButton from './FlipHorizontallyButton'
import MyFlipVerticallyButton from './FlipVerticallyButton'
import MyRotateClockwiseButton from './RotateClockwiseButton'
import MyRotateCounterclockwiseButton from './RotateCounterclockwiseButton'
import MyScalingSlider from './ScalingSlider'
import MyUploader from './Uploader'

export default {
  MyActionButton,
  MyClearButton,
  MyFlipHorizontallyButton,
  MyFlipVerticallyButton,
  MyRotateClockwiseButton,
  MyRotateCounterclockwiseButton,
  MyScalingSlider,
  MyUploader
}
